/* tslint:disable */
import {
  CompanyAccount,
  UserProfile
} from '../index';

declare var Object: any;
export interface LandlordPropertiesInterface {
  "id"?: number;
  "property_id"?: number;
  "land_lord_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  property?: CompanyAccount;
  landLord?: UserProfile;
}

export class LandlordProperties implements LandlordPropertiesInterface {
  "id": number;
  "property_id": number;
  "land_lord_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  property: CompanyAccount;
  landLord: UserProfile;
  constructor(data?: LandlordPropertiesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LandlordProperties`.
   */
  public static getModelName() {
    return "LandlordProperties";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LandlordProperties for dynamic purposes.
  **/
  public static factory(data: LandlordPropertiesInterface): LandlordProperties{
    return new LandlordProperties(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LandlordProperties',
      plural: 'LandlordProperties',
      path: 'LandlordProperties',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "land_lord_id": {
          name: 'land_lord_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        landLord: {
          name: 'landLord',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'land_lord_id',
          keyTo: 'id'
        },
      }
    }
  }
}
